import { render, staticRenderFns } from "./SortButtons.vue?vue&type=template&id=07847711&scoped=true"
import script from "./SortButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortButtons.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SortButtons.vue?vue&type=style&index=0&id=07847711&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07847711",
  null
  
)

export default component.exports